import { createBrowserClient } from '@supabase/ssr';
import { authCookieOptions } from './authCookie';

// Клиент Supabase для cortivox.
//
// URL — это ОРИГИН самого приложения (window.location.origin), а не абсолютный
// адрес Supabase. Так все запросы (/auth/v1/…, /rest/v1/…) идут на свой же
// origin и проксируются на Kong:
//   - в проде — nginx контейнера (docker/nginx.conf, location ~ ^/(rest|auth|…));
//   - в dev  — CRA dev-server (src/setupProxy.js) на REACT_APP_SUPABASE_URL.
// Браузер всегда общается со своим origin => CORS не нужен нигде, а кука сессии
// первична (first-party) и в dev, и в проде.
//
// Только anon-ключ (REACT_APP_SUPABASE_ANON_KEY). service_role сюда класть
// нельзя — он обходит RLS и попадёт в бандл, доступный любому.
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Опциональная авторизация: если ключ не задан при сборке, клиента нет, а
// функции входа деградируют мягко (см. AuthContext) — сайт продолжает работать
// как раньше, без логина.
export const supabase = SUPABASE_ANON_KEY
  ? createBrowserClient(window.location.origin, SUPABASE_ANON_KEY, {
      // Данные cortivox живут в отдельной схеме `cortivox` (question_bank,
      // doctors, scale_results). Для авторизации (GoTrue) схема роли не играет.
      // Схема должна быть открыта в PostgREST (PGRST_DB_SCHEMAS) — см. db/cortivox.
      db: { schema: 'cortivox' },
      cookieOptions: authCookieOptions(window.location),
    })
  : null;

export const isSupabaseConfigured = () => supabase !== null;
